export const services = [
  {
    name: "AI & Machine Learning",
    slug: "ai-machine-learning",
    icon: "BrainCircuit",
    span: "lg:col-span-8 lg:row-span-2",
    image:
      "https://images.pexels.com/photos/17485657/pexels-photo-17485657.png",
    tagline: "Generative AI, LLM applications & intelligent automation",
    description:
      "Generative AI, LLM applications, AI agents, RAG, machine learning and intelligent automation that deliver measurable business impact.",
    problem:
      "Organizations are under pressure to adopt AI, but struggle to move from experimentation to production-grade systems that are reliable, governed and cost-effective.",
    capabilities: [
      "Custom LLM & Generative AI applications",
      "Retrieval-Augmented Generation (RAG) systems",
      "AI agents & workflow automation",
      "Predictive & prescriptive machine learning",
      "MLOps, model monitoring & governance",
      "Computer vision & document intelligence",
    ],
    cta: "Talk to an AI Expert",
  },
  {
    name: "Data Engineering & Analytics",
    slug: "data-engineering",
    icon: "Database",
    span: "lg:col-span-4 lg:row-span-1",
    image:
      "https://images.unsplash.com/photo-1606778303077-3780ea8d5420?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Data platforms, pipelines & real-time analytics",
    description:
      "Data platforms, pipelines, analytics, BI, data modernization and real-time data that turn raw information into decisions.",
    problem:
      "Fragmented data, brittle pipelines and slow reporting keep teams from trusting their numbers and acting in real time.",
    capabilities: [
      "Cloud data platforms & lakehouses",
      "Scalable ETL / ELT pipelines",
      "Real-time & streaming data",
      "Business intelligence & dashboards",
      "Data modeling & governance",
      "Data warehouse modernization",
    ],
    cta: "Modernize Your Data",
  },
  {
    name: "Cloud & DevOps",
    slug: "cloud-devops",
    icon: "Cloud",
    span: "lg:col-span-4 lg:row-span-1",
    image:
      "https://images.unsplash.com/photo-1775519520461-6b6e068d9250?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "AWS, Azure, GCP, Kubernetes & infrastructure",
    description:
      "AWS, Azure, Google Cloud, cloud migration, DevOps, Kubernetes and infrastructure engineered for scale and resilience.",
    problem:
      "Legacy infrastructure and manual operations slow releases, raise costs and expose organizations to reliability and security risk.",
    capabilities: [
      "Cloud architecture on AWS, Azure & GCP",
      "Cloud migration & modernization",
      "CI/CD automation & DevOps",
      "Kubernetes & container platforms",
      "Infrastructure as Code",
      "Cloud cost & reliability engineering",
    ],
    cta: "Accelerate Your Cloud",
  },
  {
    name: "Enterprise Application Development",
    slug: "enterprise-applications",
    icon: "AppWindow",
    span: "lg:col-span-6 lg:row-span-1",
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Modern apps, APIs, microservices & integrations",
    description:
      "Modern applications, APIs, microservices, integrations and legacy modernization built for the enterprise.",
    problem:
      "Aging applications and disconnected systems make it hard to launch new capabilities and integrate across the business.",
    capabilities: [
      "Web & mobile application development",
      "Microservices & API platforms",
      "Systems integration & middleware",
      "Legacy application modernization",
      "Product engineering & UX",
      "Quality engineering & test automation",
    ],
    cta: "Build Your Application",
  },
  {
    name: "Engineering Solutions",
    slug: "engineering-solutions",
    icon: "Cpu",
    span: "lg:col-span-6 lg:row-span-1",
    image:
      "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tagline: "Software, product, embedded & semiconductor engineering",
    description:
      "Software engineering, product engineering, embedded systems, semiconductor and industrial engineering expertise.",
    problem:
      "Specialized engineering initiatives stall without access to deep, domain-specific technical talent and delivery capability.",
    capabilities: [
      "Software & product engineering",
      "Embedded & firmware engineering",
      "Semiconductor & electronics engineering",
      "Industrial & controls engineering",
      "Digital engineering & automation",
      "Validation, verification & test",
    ],
    cta: "Scale Your Engineering",
  },
  {
    name: "IT & Professional Staffing",
    slug: "it-staffing",
    icon: "Users",
    span: "lg:col-span-12 lg:row-span-1",
    image:
      "https://images.unsplash.com/photo-1622675363311-3e1904dc1885?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "Contract, direct hire, contract-to-hire & dedicated teams",
    description:
      "Contract staffing, direct hire, contract-to-hire, specialized recruiting and dedicated teams that deliver.",
    problem:
      "Critical roles stay open for months while projects wait for the right specialized talent to move them forward.",
    capabilities: [
      "Contract & contract-to-hire staffing",
      "Direct hire & permanent placement",
      "Specialized technical recruiting",
      "Dedicated & offshore teams",
      "Engineering & semiconductor staffing",
      "Ongoing engagement support",
    ],
    cta: "Submit a Staffing Requirement",
  },
];

export const getService = (slug) => services.find((s) => s.slug === slug);
